import Sidebar from 'components/common/sidebar/Sidebar';
import { useSidebar } from 'context/SideBarContext';
import { Menu, X } from 'lucide-react';
import React from 'react';
import { Outlet } from 'react-router-dom';

type Props = {
  children?: React.ReactNode;
};

const MainLayout = ({ children }: Props) => {
  const { toggleSidebar, isSidebarOpen } = useSidebar();

  return (
    <div className="min-h-screen flex bg-gray-100">
      <Sidebar />

      {/* Main content shifts right on desktop when sidebar is open */}
      <div
        className={`flex-1 w-full min-w-0 transition-all duration-300 ease-in-out ${
          isSidebarOpen ? 'lg:pl-64' : 'lg:pl-0'
        }`}
      >
        <header className="bg-white shadow-sm sticky top-0 z-10">
          <div className="flex items-center h-14 px-4">
            {/* Toggle button — Menu icon when closed, X when open */}
            <button
              onClick={toggleSidebar}
              className="p-1.5 rounded-md hover:bg-gray-100 text-gray-600 transition-colors"
              aria-label={isSidebarOpen ? 'Close sidebar' : 'Open sidebar'}
            >
              {isSidebarOpen ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </header>

        <main className="py-4 px-8">
          <Outlet />
          {children}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
